'use strict';

require("core-js/modules/es.promise.finally.js");

var requirePromise = require('./requirePromise');

var implementation = require('./implementation');

module.exports = function getPolyfill() {
  requirePromise();
  return typeof Promise.prototype['finally'] === 'function' ? Promise.prototype['finally'] : implementation;
};